import React from 'react';
import PropTypes from "prop-types";
import { addAlert } from '../../actions/index';
import {connect} from 'react-redux';
import tsl from '../../app/tsl';

// This function takes a component...
export default function withValidatedInputs(WrappedComponent) {

  // ...and returns another component...
  return connect(() => ({}), {addAlert})(class extends React.Component {
    components = [];

    constructor(props) {
      super(props);

      this.state = {
        invalidInputs: [],
        isSubmitted: false
      };
    }

    handleValidInput = (c) => {
      this.setState((state) => {
        const invalidInputs = state.invalidInputs.slice();
        const pos = state.invalidInputs.indexOf(c);
        if (pos === -1) {
          return state;
        }

        // delete the component from invalidInputs
        invalidInputs.splice(pos, 1);

        return {
          ...state,
          invalidInputs,
        }
      });
    };

    handleInvalidInput = (c) => {
      this.setState((state) => {
        const pos = state.invalidInputs.indexOf(c);
        if (pos !== -1) {
          return state;
        }

        const invalidInputs = state.invalidInputs.slice();
        invalidInputs.push(c);

        return {
          ...state,
          invalidInputs,
        }
      });
    };

    isValid = () => {
      // console.log(['InvalidInputs', this.state.invalidInputs.slice().map(e => e.props.name)]);
      return this.state.invalidInputs.length === 0;
    };

    handleSubmit = () => {
      this.setState({
        isSubmitted: true
      });

      if (!this.isValid()) {
        this.props.addAlert(tsl('validations.form_not_valid'), 'error');
        return false;
      }

      return true;
    };

    handleReset = () => {
      this.setState({
        isSubmitted: false,
        invalidInputs: []
      });

      for (var i = 0; i < this.components.length; i++) {
        if (this.components[i] !== null) {
          this.components[i].reset && this.components[i].reset();
        }
      }
    };

    registerValidatedInput = (component) => {
      if (this.components.indexOf(component) === -1) {
        this.components.push(component);
      }
    };

    unregisterValidatedInput = (component) => {
      const i = this.components.indexOf(component);
      if (i !== -1) {
        this.handleValidInput(component); // remove this component from invalid inputs list
        this.components.splice(i, 1); // remove it from component list
      }
    };

    render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
      return <WrappedComponent
        formActions={{
          onValid: this.handleValidInput,
          onInvalid: this.handleInvalidInput,
          isFormSubmitted: this.state.isSubmitted,
          register: this.registerValidatedInput,
          unregister: this.unregisterValidatedInput
        }}
        handleValidInput={this.handleValidInput}
        handleInvalidInput={this.handleInvalidInput}
        isFormValid={this.isValid()}
        isFormSubmitted={this.state.isSubmitted}
        trySubmit={this.handleSubmit}
        resetFormErrors={this.handleReset}
        {...this.props}
      />;
    }
  });
}


// WEBPACK FOOTER //
// ./components/forms/withValidatedInputs.js